module.exports = __webpack_public_path__ + "static/media/payment-failed.eafe1fbb.svg";